var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgHolidaysFireworksStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.25 19 6-6M5.25 3v.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 7v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.25 5h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.25 5h.5M19.25 17v.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.25 21v-.5M21.25 19h-.5M17.25 19h.5M10.25 20l2-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.25 14 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.164 12.572-.827-2.659-2.66-.827a.608.608 0 0 1-.17-1.076l2.274-1.608-.036-2.785a.608.608 0 0 1 .972-.495l2.232 1.665 2.637-.894a.608.608 0 0 1 .77.77l-.893 2.638 1.665 2.232a.608.608 0 0 1-.495.972l-2.785-.036-1.608 2.274a.608.608 0 0 1-1.076-.17z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 24h-24V0h24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaysFireworksStar);
export default __webpack_public_path__ + "static/media/holidaysFireworksStar.d6ac462445b55f0dc5693a9dfaf45fa7.svg";
export { ForwardRef as ReactComponent };